export const PRODUCT_REMOVED = 'product-removed';
export const MODAL_CLOSED = 'modal-closed';
